import { createFileRoute, useSearch } from '@tanstack/react-router';
import { useTheme, useMediaQuery } from '@mui/material';
import { useCallback } from 'react';
import { navigateTo, useAuth, UserSettingsForm, useGetViewer } from '@amber-ui/core';

function UserSettingsRoute() {
  const theme = useTheme();
  // down('md') = < 960px, matches AuthLayout's mobile_width definition (width === 'sm' || 'xs').
  // Previously used down('sm') || only('xs') which was < 600px — inconsistent with AuthLayout.
  const matchesMobile = useMediaQuery(theme.breakpoints.down('md'));
  const mobile_width = matchesMobile;

  const { viewer } = useGetViewer();
  // Read acct from URL search params (source of truth)
  const { acct } = useSearch({ strict: false }) as { acct?: string };
  const { account_id: session_account_id } = useAuth();
  const effectiveAccountId = acct || session_account_id || '';

  const onSubmitSuccess = useCallback(() => {
    navigateTo('/grain_bin/dashboard');
  }, []);

  if (!viewer) return null;

  return (
    <UserSettingsForm
      account_id={effectiveAccountId}
      user_id={viewer.user.user_id}
      selected_user={viewer.user}
      onSubmitSuccess={onSubmitSuccess}
      onUpdateUserFormSuccess={onSubmitSuccess}
      onUserPasswordFormSuccess={onSubmitSuccess}
      mobile_width={mobile_width}
    />
  );
}

export const Route = createFileRoute('/_auth/user/settings')({
  component: UserSettingsRoute,
});
